import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=5705232e&scoped=true&"
import script from "./Apps.vue?vue&type=script&lang=js&"
export * from "./Apps.vue?vue&type=script&lang=js&"
import style0 from "./Apps.vue?vue&type=style&index=0&id=5705232e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5705232e",
  null
  
)

export default component.exports